import { useEffect, useRef } from 'react';
import { LinkIcon } from 'foundations-assets/icons/components/LinkIcon';
import { SprocketIcon } from 'foundations-assets/icons/components/SprocketIcon';
import { Flex } from 'foundations-components/components/Flex';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { H3 } from 'foundations-components/transitional/components/H3';
import { H4 } from 'foundations-components/transitional/components/H4';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Image } from 'foundations-components/transitional/components/Image';
import { Link } from 'foundations-components/transitional/components/Link';
import { Modal } from 'foundations-components/transitional/components/Modal';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useDetailsPageContext } from 'marketplace-ui-common/context/DetailsPageContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const POLL_INTERVAL_MS = 30 * 1000;
const MAX_POLL_DURATION_MS = 5 * 60 * 1000;
export function PartnerLinkInstallModal({
  installUrl,
  onClose,
  refetchInstallStatus
}) {
  const {
    iconUrl,
    name,
    trackInstall,
    trackInteraction
  } = useDetailsPageContext();
  const refetchRef = useRef(refetchInstallStatus);
  const onCloseRef = useRef(onClose);
  const trackInteractionRef = useRef(trackInteraction);

  // Keep refs current without restarting the polling effect
  useEffect(() => {
    refetchRef.current = refetchInstallStatus;
    onCloseRef.current = onClose;
    trackInteractionRef.current = trackInteraction;
  });
  useEffect(() => {
    const startTime = Date.now();
    let cancelled = false;
    let timeoutId;
    const poll = async () => {
      try {
        var _result$data;
        const result = await refetchRef.current();
        if (cancelled) {
          return;
        }
        if (result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.installed) {
          onCloseRef.current();
          return;
        }
      } catch (e) {
        // ignore and retry on the next interval
      }
      if (cancelled) {
        return;
      }
      if (Date.now() - startTime + POLL_INTERVAL_MS > MAX_POLL_DURATION_MS) {
        trackInteractionRef.current({
          action: `integration not installed within ${MAX_POLL_DURATION_MS / 60000} minutes`
        });
        return;
      }
      timeoutId = setTimeout(poll, POLL_INTERVAL_MS);
    };

    // Start checking immediately, then every 30s for up to 5 minutes
    void poll();
    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
    };
  }, []);
  return /*#__PURE__*/_jsxs(Modal, {
    width: 600,
    centered: true,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H3, {
        textAlign: "left",
        inlineSize: "100%",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.productDetailsCard.cta.partnerLinkInstallModal.header",
          options: {
            name
          }
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "center",
        children: [/*#__PURE__*/_jsx(Image, {
          src: iconUrl,
          blockSize: "64px",
          objectFit: "contain",
          responsive: false
        }), /*#__PURE__*/_jsx(IconHolder, {
          icon: LinkIcon,
          size: "400",
          paddingBlock: "0",
          paddingInlineEnd: "0",
          color: "icon-secondary-default"
        }), /*#__PURE__*/_jsx(IconHolder, {
          icon: SprocketIcon,
          size: "1000",
          padding: "0",
          color: "fill-accent-light-orange-default"
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "200",
        marginBlock: "200",
        children: [/*#__PURE__*/_jsx(H4, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "detailsPage.productDetailsCard.cta.partnerLinkInstallModal.body",
            options: {
              name
            }
          })
        }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "detailsPage.productDetailsCard.cta.partnerLinkInstallModal.footer_jsx",
          elements: {
            Link
          },
          options: {
            name,
            href: installUrl,
            external: true,
            onclick: () => trackInstall({})
          }
        })]
      })]
    })]
  });
}